import React from "react";
import "../../Styles/yellowcalf.css/Invoices.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlassPlus } from "@fortawesome/free-solid-svg-icons";

function Invoices() {
  return (
    <div className="inv-container" >
      {/* HEADING PANEL */}
      <div className="inv-heading-panel shadow-sm mb-4">
        <div className="inv-heading-body">
          <h3 className="inv-heading-title">Invoices</h3>
        </div>
      </div>
      <div className="inv-filters d-flex flex-wrap gap-3">
        <input
          type="text"
          className="inv-input"
          placeholder="Search Invoice No."
        />

        <input
          type="text"
          className="inv-input"
          placeholder="Search Date"
        />
      </div>

      {/* INVOICE LIST PANEL */}

      <div className="inv-list-body">
        <div className="inv-table-wrapper">
          <table className="inv-table">
            <colgroup>
              <col />
              <col />
              <col />
              <col />
              <col style={{ width: "50px" }} />
            </colgroup>
            <thead>
           
              <tr>
                <th>Sr.No</th>
                <th>
                  <a
                    className="inv-sort-link"
                    href="/accountant/invoice/index?sort=invoice_id"
                  >
                    Invoice Number
                  </a>
                </th>
                <th>
                  <a
                    className="inv-sort-link"
                    href="/accountant/invoice/index?sort=invoice_date"
                  >
                    Invoice Date
                  </a>
                </th>
                <th>
                  <a
                    className="inv-sort-link"
                    href="/accountant/invoice/index?sort=invoice_amount"
                  >
                    Invoice Amount
                  </a>
                </th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>1</td>
                <td>877</td>
                <td>Mon Jul 27 2020</td>
                <td>$ 2700</td>
                <td style={{ textAlign: "right" }}>
                  <a href="/accountant/invoice/Pending_Invoices_Invoice" className="inv-view-btn">
                    <i class="bi bi-eye" ></i>
                  </a>
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>900</td>
                <td>Tue Aug 11 2020</td>
                <td>$ 1500</td>
                <td style={{ textAlign: "right" }}>
                  <a href="/accountant/invoice/Pending_Invoices_Invoice" className="inv-view-btn">
                    <i class="bi bi-eye" ></i>
                  </a>
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>901</td>
                <td>Tue Aug 11 2020</td>
                <td>$ 1800</td>
                <td style={{ textAlign: "right" }}>
                  <a href="/accountant/invoice/Pending_Invoices_Invoice" className="inv-view-btn">
                    <i class="bi bi-eye" ></i>
                  </a>
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>900</td>
                <td>Tue Aug 11 2020</td>
                <td>$ 1500</td>
                <td style={{ textAlign: "right" }}>
                  <a href="/accountant/invoice/Pending_Invoices_Invoice" className="inv-view-btn">
                    <i class="bi bi-eye" ></i>
                  </a>
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>900</td>
                <td>Tue Aug 11 2020</td>
                <td>$ 1500</td>
                <td style={{ textAlign: "right" }}>
                  <a href="/accountant/invoice/Pending_Invoices_Invoice" className="inv-view-btn">
                    <i class="bi bi-eye" ></i>
                  </a>
                </td>
              </tr>

            </tbody>
          </table>
          <div className="wallet-main-footer">
            <ul className="wallet-main-pagination">
              <li className="wallet-main-active">
                <a href="#">1</a>
              </li>
              <li>
                <a href="#">2</a>
              </li>
              <li>
                <a href="#">3</a>
              </li>
            </ul>

            <div className="wallet-main-summary">
              Showing <b>1-50</b> of <b>177</b> items.
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default Invoices;
